import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { useI18n } from '@/hooks/useI18n';

interface SharedLinksTableSkeletonProps {
  rows?: number;
  className?: string;
}

export const SharedLinksTableSkeleton: React.FC<SharedLinksTableSkeletonProps> = ({
  rows = 5,
  className,
}) => {
  const { t } = useI18n();

  return (
    <div className={`overflow-x-auto ${className ?? ''}`} aria-hidden="true">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[18%]">{t('shared.itinerary')}</TableHead>
            <TableHead className="w-[16%]">{t('shared.users')}</TableHead>
            <TableHead className="w-[10%]">{t('shared.password')}</TableHead>
            <TableHead className="w-[14%]">{t('shared.expiration')}</TableHead>
            <TableHead className="w-[32%]">{t('shared.link')}</TableHead>
            <TableHead className="text-right w-[10%]">{t('common.actions')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {Array.from({ length: rows }).map((_, i) => (
            <TableRow key={i}>
              {/* Itinerary name — blue link */}
              <TableCell>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4" />
              </TableCell>

              {/* Users — client badge + advisor badge stacked */}
              <TableCell>
                <div className="flex flex-col gap-1">
                  <div className="h-5 bg-gray-200 rounded-full animate-pulse w-20" />
                  <div className="h-5 bg-gray-200 rounded-full animate-pulse w-24" />
                </div>
              </TableCell>

              {/* Password — mono dots */}
              <TableCell>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-16" />
              </TableCell>

              {/* Expiration — date text + active/expired badge */}
              <TableCell>
                <div className="flex flex-col gap-1">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-24" />
                  <div className="h-5 bg-gray-200 rounded-full animate-pulse w-14" />
                </div>
              </TableCell>

              {/* Share link — monospace URL + copy button */}
              <TableCell>
                <div className="flex items-center gap-2">
                  <div className="h-4 bg-gray-200 rounded animate-pulse flex-1 max-w-[250px]" />
                  <div className="h-7 w-9 bg-gray-200 rounded animate-pulse shrink-0" />
                </div>
              </TableCell>

              {/* Actions — dropdown trigger */}
              <TableCell className="text-right">
                <div className="h-8 w-8 bg-gray-200 rounded animate-pulse ml-auto" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
